import { Crossword } from "./models/crossword";
import { GridCellState } from "./GridCellState";
import { Clue } from "./models/clue";

export function createGrid(crossword: Crossword | null): GridCellState[][] {
    const size:number = crossword?.size || 15;
    // Initialize an empty grid with the given size
    const grid: GridCellState[][] = Array.from({ length: size }, () =>
        Array.from({ length: size }, () => new GridCellState())
    );

    if (crossword === null) {
        return grid;
    }

    // Populate the grid with the clues
    for (const clue of crossword.clues) {
        let row = clue.row;
        let col = clue.column;
        grid[row][col].clueNum.addClue(clue.clueNumber, clue.isAcross);
        for (let i = 0; i < clue.length; i++) {
            grid[row][col].setContainingClueNum(clue);
            grid[row][col].showText = true;
            grid[row][col].solutionText = clue.answer[i];
            if (clue.isAcross) {
                col++;
            } else {
                row++;
            }
        }
    }

    return grid;
}

  export function CluesInGroup(clues: Clue[], containingClue: Clue | null): Clue[] {
    if (containingClue === null || containingClue.group === "") {
      return [];
    }
    const result: Clue[] = containingClue.group.split("").map((letter) => {
      // If lowercase, convert to uppercase and shift by 2 positions (with wrap-around)
      if (letter >= "a") {
        const num = letter.charCodeAt(0) - "a".charCodeAt(0) + 1;
        return clues.filter(
          (clue) => clue.clueNumber === num && !clue.isAcross
        )[0];
      } else {
        const num = letter.charCodeAt(0) - "A".charCodeAt(0) + 1;
        return clues.filter(
          (clue) => clue.clueNumber === num && clue.isAcross
        )[0];
      }
    });
    return result;
  }

